import React from "react";
import "./PrivacyPopup.css";

export default class PrivacyPopup extends React.Component {
  state = {
    privacyAccepted: localStorage.getItem("privacy") === "true" || false,
  };

  constructor(props) {
    super(props);
    this.acceptPrivacyPolicy = this.acceptPrivacyPolicy.bind(this);
  }

  acceptPrivacyPolicy() {
    this.setState({ privacyAccepted: true });
    localStorage.setItem("privacy", "true");
  }

  render() {
    return (
      <div>
        {!this.state.privacyAccepted && (
          <div className="privacy-wrapper">
            <div className="privacy-popup">
              <div className="privacy-popup__statement">
                <p className="privacy-popup__text">
                  This website uses cookies to provide a superior user
                  experience.
                </p>
                <p className="privacy-popup__text">
                  For more information, please take a look at our{" "}
                  <a href="/privacy">Privacy Policy</a>.
                </p>
              </div>
              <div className="privacy-popup__accept-wrapper">
                <button
                  className="privacy-popup__accept"
                  onClick={this.acceptPrivacyPolicy}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
